import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { API_URL } from "../../../utils/constant";
import { Pen, Trash } from "lucide-react";
import { customTableStyles } from "../../../utils/tableStylings";
import CompanyWarehouseModal from "./warehouse_model";

const CompanyWarehouse = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchWarehouses = async () => {
        try {
            setLoading(true);
            const company_id = localStorage.getItem("companyID");
            const res = await axios.get(
                `${API_URL}/company-warehouses/${company_id}`
            );
            setWarehouses(res.data.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWarehouses();
    }, []);

    const handleAdd = () => {
        setEditData(null);
        setShowModal(true);
    };

    const handleEdit = (row) => {
        setEditData(row);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This will delete the warehouse!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirm.isConfirmed) return;

        try {
            await axios.delete(`${API_URL}/company-warehouses/${id}`);
            Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Warehouse deleted successfully",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
            fetchWarehouses();
        } catch {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to delete warehouse",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
        }
    };

    const columns = [
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Code", selector: (row) => row.code, sortable: true },
        { name: "Type", selector: (row) => row.type, sortable: true },
        {
            name: "Location",
            selector: (row) => row.location?.name,
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => handleEdit(row)}
                    >
                        <Pen />
                    </button>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Trash />
                    </button>
                </>
            ),
            ignoreRowClick: true,
            button: true,
        },
    ];

    return (
        <>
            <div className="row" style={{ marginTop: "60px" }}>
                <div className="col-12">

                    <div className="card" >
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="text-primary mb-0">Company Warehouses</h3>
                            <button className="btn btn-primary" onClick={handleAdd}>
                                + Add Warehouse
                            </button>
                        </div>

                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={warehouses}
                                progressPending={loading}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customTableStyles}
                            />
                        </div>

                        {showModal && (
                            <CompanyWarehouseModal
                                show={showModal}
                                heading={editData ? "Edit Warehouse" : "Add Warehouse"}
                                initialData={editData}
                                onClose={() => setShowModal(false)}
                                onSuccess={fetchWarehouses}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyWarehouse;
